import './index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { App } from './App';

/**
 * Load Google Fonts (Oswald + Inter) WITHOUT blocking the first render.
 *
 * - Adds `preconnect` to fonts.googleapis.com and fonts.gstatic.com
 *   (the latter with crossorigin) so the connection is warm early.
 * - Loads the font stylesheet with the `media="print"` + `onload` swap trick
 *   so the browser fetches it at low priority and applies it once ready,
 *   instead of blocking the critical rendering path.
 *
 * `font-display=swap` (in the URL) keeps text visible with the fallback font
 * until the web fonts arrive, so there is no invisible-text flash.
 */
const FONTS_HREF = 'https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&family=Inter:wght@400;500;600;700;800&display=swap';
function loadFontsAsync() {
  const head = document.head;
  const addPreconnect = (href: string, crossOrigin?: boolean) => {
    if (head.querySelector(`link[rel="preconnect"][href="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = href;
    if (crossOrigin) link.crossOrigin = 'anonymous';
    head.appendChild(link);
  };

  // (a) Warm up the font origins before requesting the stylesheet.
  addPreconnect('https://fonts.googleapis.com');
  addPreconnect('https://fonts.gstatic.com', true);

  // (b) Load the stylesheet asynchronously (non-render-blocking).
  if (!head.querySelector(`link[data-fonts="google"]`)) {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = FONTS_HREF;
    link.setAttribute('data-fonts', 'google');
    // Fetch without blocking rendering, then apply once loaded.
    link.media = 'print';
    link.onload = () => {
      link.media = 'all';
    };
    head.appendChild(link);

    // No-JS / edge fallback so the stylesheet still applies.
    const noscript = document.createElement('noscript');
    const fallback = document.createElement('link');
    fallback.rel = 'stylesheet';
    fallback.href = FONTS_HREF;
    noscript.appendChild(fallback);
    head.appendChild(noscript);
  }
}
loadFontsAsync();
const rootEl = document.getElementById('root');
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-307" data-mp="3rtqdwmm8ox9i" />);
}